import React, { PureComponent } from 'react'
import { Modal } from 'antd'
import { ChromePicker } from 'react-color'

class ColorModal extends PureComponent {
    state = {
        color: ''
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen) {
            this.setState({
                color: nextProps.color
            })
        }
    }

    onChangeColor(color) {
        this.setState({ color })
    }

    render() {
        let { isOpen, onOk } = this.props
        return (
            <Modal
                centered
                visible={isOpen}
                footer={null}
                width={'auto'}
                onCancel={() => onOk(this.state.color)}
                wrapClassName="color-modal">
                <ChromePicker
                    disableAlpha
                    color={this.state.color}
                    onChange={e => this.onChangeColor(e.hex)}
                />
            </Modal>
        )
    }
}

export default ColorModal
